import styled from '@emotion/styled';
import React from 'react';

import { Answer } from 'src/modules/assessments/components/Answer';
import { mediaQueries } from 'src/shared/styles/variables';
import { SingleSelectQuestionTestId } from './testIds';

const RangeQuestionHolder = styled('div')({
    textAlign: 'center',
});

const Answers = styled('ul')({
    width: 500,
    listStyleType: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 0,
    [mediaQueries.md]: {
        flexDirection: 'column',
    },
});

interface Option {
    answerText: string;
    value: string | number;
}

interface Props {
    options: Option[];
    currentRate: string;
    onRateChange: (value: string | number) => void;
}

export const SingleSelectQuestion: React.FC<Props> = ({ currentRate, onRateChange, options }) => (
    <RangeQuestionHolder>
        <Answers>
            {options.map(({ answerText, value }) => (
                <Answer
                    data-testid={SingleSelectQuestionTestId.Option + value}
                    key={value}
                    isHighlighted={value === currentRate}
                    onClick={() => onRateChange(value)}
                >
                    {answerText}
                </Answer>
            ))}
        </Answers>
    </RangeQuestionHolder>
);
